import React from 'react';

const LightBulb = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.9597 16.3369C23.2299 14.9198 24 13.0522 24 11C24 6.58172 20.4183 3 16 3C11.5817 3 8 6.58172 8 11C8 13.0522 8.7701 14.9198 10.0403 16.3369C11.4277 17.885 13 20.1 13 22.8311V23.5H19V22.8311C19 20.1 20.5723 17.885 21.9597 16.3369ZM11 22.8311V23.5H10.9999V26C10.9999 28.7614 13.2385 31 15.9999 31L11 23.5L16 31C16.287 31 16.5683 30.9758 16.8421 30.9294C19.2025 30.5291 21 28.4744 21 26V22.8311C21 20.8699 22.1402 19.1322 23.4491 17.6718C25.0353 15.902 26 13.5637 26 11C26 5.47715 21.5228 1 16 1C10.4772 1 6 5.47715 6 11C6 13.5637 6.9647 15.902 8.5509 17.6718C9.85983 19.1322 11 20.8699 11 22.8311ZM12.2499 12.2503C12.9403 12.2503 13.4999 11.6907 13.4999 11.0003C13.4999 10.31 12.9403 9.75035 12.2499 9.75035C11.5596 9.75035 10.9999 10.31 10.9999 11.0003C10.9999 11.6907 11.5596 12.2503 12.2499 12.2503ZM17.2499 11.0003C17.2499 11.6907 16.6903 12.2503 15.9999 12.2503C15.3096 12.2503 14.7499 11.6907 14.7499 11.0003C14.7499 10.31 15.3096 9.75035 15.9999 9.75035C16.6903 9.75035 17.2499 10.31 17.2499 11.0003ZM19.7499 12.2503C20.4403 12.2503 20.9999 11.6907 20.9999 11.0003C20.9999 10.31 20.4403 9.75035 19.7499 9.75035C19.0596 9.75035 18.4999 10.31 18.4999 11.0003C18.4999 11.6907 19.0596 12.2503 19.7499 12.2503Z"
      fill="#A0ABB8"
    />
  </svg>
);

export default LightBulb;
